import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { AppState } from 'src/app/app.reducer';
import { Store } from '@ngrx/store';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { FormBuilder, FormArray } from '@angular/forms';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { GetShareSuggestions } from '../../resources/_store/resources.actions';
import { UpdateTaskDetails } from '../store/tasks.actions'
import { CheckViewAccessGorDocStart, ClearViewAccess } from '../../user-messages/_store/messages.actions';
import { Subject } from 'rxjs';
import { NotificationModalComponent } from 'src/app/features/common-components/notification-modal/notification-modal.component';
import { DocAccessPermissionComponent } from 'src/app/features/common-components/doc-access-permission/doc-access-permission.component';

@Component({
    selector: 'app-edit-approvers-endorsers-dialog',
    templateUrl: './edit-approvers-endorsers-dialog.component.html',
    styleUrls: ['./edit-approvers-endorsers-dialog.component.scss']
})
export class EditApproversEndorsersDialogComponent implements OnInit, OnDestroy {
  
    approversForm;
    selectedMembers: any = [];
    dropDownList$: any;
    taskId: string;
    membersList: Array<any> = [];
    submitButtonClicked: boolean;
    stopper$: Subject<any> = new Subject();
    userId;

    constructor(
        private matDialogRef: MatDialogRef<EditApproversEndorsersDialogComponent>,
        private fb: FormBuilder,
        private dialog: MatDialog,
        private store: Store<AppState>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.matDialogRef.disableClose = true;
        this.taskId = this.data.allDetails._id;
        this.approversForm = this.fb.group({
            memberArray: this.fb.array([])
        });

        if (this.data.type == "approvers") {
            this.membersList = this.data.allDetails.approvers;
            console.log(this.membersList);
        }
        else if(this.data.type == 'endorsers'){
            this.membersList = this.data.allDetails.endorsers;
        }

        if (this.membersList.length == 0) {
            this.addMember();
        } else {
            this.store.dispatch(new GetShareSuggestions('', 'user'));
            const member = this.approversForm.controls.memberArray as FormArray;
            this.selectedMembers = this.membersList.map(mem => mem._id);
            this.membersList.map(mem => {
                const memberCtrl = this.fb.group({
                    'member': [mem],
                });
                member.push(memberCtrl);
            });
            console.log(this.approversForm.controls.memberArray)
        }
    }

    ngOnInit() {
        this.store.select(state =>state.auth.user).pipe(takeUntil(this.stopper$)).subscribe(user => {
            if (user) {
                this.userId = (user.details || {})._id;
            }
        });
        this.store.dispatch(new ClearViewAccess());
        this.dropDownList$ = this.store.select(state => state.resources.shareSuggestions);

        this.store.select(state => state.messages.viewAccessForDoc).pipe(takeUntil(this.stopper$)).subscribe((resp) => {
            if (resp && resp.length > 0 && resp[0].users.length > 0 && this.submitButtonClicked) {
              const { documents, noAccessDocuments, ...others } = resp;
            //   const users = Object.keys(others).some(key => others[key].length);
            //   const noAccess = (noAccessDocuments || []).length;
            //   if (users || noAccess) {
                const dialogRef = this.dialog.open(DocAccessPermissionComponent, {
                  width: '700px',
                  hasBackdrop: true,
                  panelClass: 'cmp-modal',
                  data: {
                    type: 'task',
                    detail: [...resp],
                    // yesButtonText :'Provide Access',
                    // noButtonText: 'Restrict Access'
                  }
                });
                dialogRef.afterClosed().subscribe((response) => {
                    // const payload = {};
                    // if (this.data.type === 'approvers') {
                    //     payload['approvers'] = this.selectedMembers;
                    // } else {
                    //     payload['endorsers'] = this.selectedMembers;
                    // }
                    // this.store.dispatch(new UpdateTaskDetails(this.taskId, payload));
                    if (response) {
                        this.matDialogRef.close(this.selectedMembers);
                    } else {
                        this.matDialogRef.close('');
                    }
                });
              }
            //     const payload = {};
            //         if (this.data.type === 'approvers') {
            //             payload['approvers'] = this.selectedMembers;
            //         } else {
            //             payload['endorsers'] = this.selectedMembers;
            //         }
            //         this.store.dispatch(new UpdateTaskDetails(this.taskId, payload));
            //         this.matDialogRef.close(this.selectedMembers);
            //   }

          });
    }

    checkStatus(i) {
        const memberArray = this.approversForm.controls.memberArray as FormArray;
        return (typeof (memberArray.controls[i].get('member').value) === 'object');
    }

    addMember() {
        const member = this.approversForm.controls.memberArray as FormArray;
        const memberCtrl = this.fb.group({
            'member': [''],
        });
        member.push(memberCtrl);
        memberCtrl.valueChanges.pipe(debounceTime(500), distinctUntilChanged()).subscribe((val) => {
            if (val.member && val.member.length) {
                this.store.dispatch(new GetShareSuggestions(val.member.trim(), 'user'));
            }
        });
    }

    removeUser(i, formControl) {
        const memberArrayCtrl = this.approversForm.controls.memberArray as FormArray;
        memberArrayCtrl.removeAt(i);
        const index = (this.selectedMembers || []).findIndex((id) => id === formControl.value.member._id);
        if (index > -1) {
            this.selectedMembers.splice(index, 1);
        }
    }

    selected(event) {
        this.selectedMembers.push(event.option.value._id);
    }

    displayFnForApprover(selectedValue) {
        if (selectedValue && Object.keys(selectedValue).length) {
            return selectedValue.key ? selectedValue.key : ((selectedValue.firstName || '') + ' ' + (selectedValue.middleName || '') + ' ' + (selectedValue.lastName || '') + '  (' + (selectedValue.role || '') + ')');
        }
    }

    addApproversOrEndorsersToTask() {
        // const payload = {};
        const docIds = (this.data.allDetails.documents || []).map(({_id}) => _id);
        const members = this.selectedMembers.filter(mem => mem !== this.userId);
        const checkObj = {
            userIds: [...members],
            docIds: docIds,
            unique: true
        };
        console.log(this.selectedMembers);
        if(members.length && docIds.length > 0) {
            this.store.dispatch(new ClearViewAccess());
            this.store.dispatch(new CheckViewAccessGorDocStart(checkObj));
        }
        else {
            this.matDialogRef.close(this.selectedMembers);
        }
        this.submitButtonClicked = true;
        // this.matDialogRef.close();
        // this.matDialogRef.close(this.selectedMembers);
    }

    cancel() {
        // this.stopper$.next();
        // this.stopper$.complete();
        this.matDialogRef.close('');
    }
    ngOnDestroy() {
        this.stopper$.next();
        this.stopper$.complete();
        }

}
